export default __webpack_public_path__ + "static/media/james1.17a668c7.png";